import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterStateUrl } from '@sd-portal/shared/util';
import { State } from '..';
import * as fromPersonProfile from './person-profile.reducer';

// feature selectors
const getSharedAuditState = createFeatureSelector<State>('sharedAudit');
const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

// feature slice - person profile
const getPersonProfileSubState = createSelector(getSharedAuditState, state => state.personProfile);

// person profile slice selectors
const getPersonProfileSkeletonState = createSelector(
  getPersonProfileSubState,
  state => state.personProfileSkeleton
);
const getPersonProfileAuditState = createSelector(
  getPersonProfileSubState,
  state => state.personProfileAudit
);
const getBusinessPersonAuditState = createSelector(
  getPersonProfileSubState,
  state => state.businessPersonAudit
);
const getPhoneNumberAuditState = createSelector(
  getPersonProfileSubState,
  state => state.phoneNumberAudit
);
const getEmailAddressAuditState = createSelector(
  getPersonProfileSubState,
  state => state.emailAddressAudit
);
const getAddressAuditState = createSelector(getPersonProfileSubState, state => state.addressAudit);
const getEmergencyContactAuditState = createSelector(
  getPersonProfileSubState,
  state => state.emergencyContactAudit
);
const getEmergencyContactPhoneNumberAuditState = createSelector(
  getPersonProfileSubState,
  state => state.emergencyContactPhoneNumberAudit
);
const getPersonAttributeAuditState = createSelector(
  getPersonProfileSubState,
  state => state.personAttributeAudit
);
const getPersonStaffGroupAuditState = createSelector(
  getPersonProfileSubState,
  state => state.personStaffGroupAudit
);
const getStaffInfoAuditState = createSelector(
  getPersonProfileSubState,
  state => state.staffInfoAudit
);
const getPreferenceCateringAuditState = createSelector(
  getPersonProfileSubState,
  state => state.preferenceCateringAudit
);
const getPreferenceGroundTransportationAuditState = createSelector(
  getPersonProfileSubState,
  state => state.preferenceGroundTransportationAudit
);
const getPreferenceHotelAuditState = createSelector(
  getPersonProfileSubState,
  state => state.preferenceHotelAudit
);
const getExecutiveAssociateAuditState = createSelector(
  getPersonProfileSubState,
  state => state.executiveAssociateAudit
);
const getExecutiveAssociatePhoneNumberAuditState = createSelector(
  getPersonProfileSubState,
  state => state.executiveAssociatePhoneNumberAudit
);
const getExecutiveAssociateEmailAuditState = createSelector(
  getPersonProfileSubState,
  state => state.executiveAssociateEmailAudit
);
const getCrewMemberTypeRatingAuditState = createSelector(
  getPersonProfileSubState,
  state => state.crewMemberTypeRatingAudit
);
const getCrewMemberTypeRatingTypesState = createSelector(
  getPersonProfileSubState,
  state => state.crewMemberTypeRatingTypes
);
const getTaxInfoAuditState = createSelector(getPersonProfileSubState, state => state.taxInfoAudit);
const getPassengerAuditState = createSelector(
  getPersonProfileSubState,
  state => state.passengerAudit
);

// router param selector
export const getPersonId = createSelector(getRouterState, state => +state.state.params['id']);

//skeleton
export const getPersonProfileSkeletonLoaded = createSelector(
  getPersonProfileSkeletonState,
  state => state.loaded
);
export const getPersonProfileSkeletonLoading = createSelector(
  getPersonProfileSkeletonState,
  state => state.loading
);
// const getPersonProfileSkeletonError = createSelector(
//   getPersonProfileSkeletonState,
//   state => state.error
// );
// const getPersonProfileAuditSkeletons = createSelector(
//   getPersonProfileSkeletonState,
//   getPersonProfileSkeletonLoaded,
//   (state, isLoaded) => {
//     return isLoaded ? state.entities : null;
//   }
// );
export const getAircraftProfileAuditSkeleton = createSelector(
  getPersonProfileSkeletonState,
  getPersonProfileSkeletonLoaded,
  getPersonId,
  (state, isLoaded, personId) => {
    return isLoaded ? state.entities[personId] : null;
  }
);

//personprofile
export const getPersonProfileAuditLoaded = createSelector(
  getPersonProfileAuditState,
  state => state.loaded
);
export const getPersonProfileAuditLoading = createSelector(
  getPersonProfileAuditState,
  state => state.loading
);
export const getPersonProfileAudits = createSelector(
  getPersonProfileAuditState,
  fromPersonProfile.personProfileAuditSelectors.selectAll
);

//businessperson
export const getBusinessPersonAuditLoaded = createSelector(
  getBusinessPersonAuditState,
  state => state.loaded
);
export const getBusinessPersonAuditLoading = createSelector(
  getBusinessPersonAuditState,
  state => state.loading
);
export const getBusinessPersonAudits = createSelector(
  getBusinessPersonAuditState,
  fromPersonProfile.businessPersonAuditSelectors.selectAll
);

//phonenumber
export const getPhoneNumberAuditLoaded = createSelector(
  getPhoneNumberAuditState,
  state => state.loaded
);
export const getPhoneNumberAuditLoading = createSelector(
  getPhoneNumberAuditState,
  state => state.loading
);
export const getPhoneNumberAudits = createSelector(
  getPhoneNumberAuditState,
  fromPersonProfile.phoneNumberAuditSelectors.selectAll
);

//emailaddress
export const getEmailAddressAuditLoaded = createSelector(
  getEmailAddressAuditState,
  state => state.loaded
);
export const getEmailAddressAuditLoading = createSelector(
  getEmailAddressAuditState,
  state => state.loading
);
export const getEmailAddressAudits = createSelector(
  getEmailAddressAuditState,
  fromPersonProfile.emailAddressAuditSelectors.selectAll
);

//address
export const getAddressAuditLoaded = createSelector(getAddressAuditState, state => state.loaded);
export const getAddressAuditLoading = createSelector(getAddressAuditState, state => state.loading);
export const getAddressAudits = createSelector(
  getAddressAuditState,
  fromPersonProfile.addressAuditSelectors.selectAll
);

//emergencycontact
export const getEmergencyContactAuditLoaded = createSelector(
  getEmergencyContactAuditState,
  state => state.loaded
);
export const getEmergencyContactAuditLoading = createSelector(
  getEmergencyContactAuditState,
  state => state.loading
);
export const getEmergencyContactAudits = createSelector(
  getEmergencyContactAuditState,
  fromPersonProfile.emergencyContactAuditSelectors.selectAll
);

//emergencycontactphonenumber
export const getEmergencyContactPhoneNumberAuditLoaded = createSelector(
  getEmergencyContactPhoneNumberAuditState,
  state => state.loaded
);
export const getEmergencyContactPhoneNumberAuditLoading = createSelector(
  getEmergencyContactPhoneNumberAuditState,
  state => state.loading
);
export const getEmergencyContactPhoneNumberAudits = createSelector(
  getEmergencyContactPhoneNumberAuditState,
  fromPersonProfile.emergencyContactPhoneNumberAuditSelectors.selectAll
);

//personattribute
export const getPersonAttributeAuditLoaded = createSelector(
  getPersonAttributeAuditState,
  state => state.loaded
);
export const getPersonAttributeAuditLoading = createSelector(
  getPersonAttributeAuditState,
  state => state.loading
);
export const getPersonAttributeAudits = createSelector(
  getPersonAttributeAuditState,
  fromPersonProfile.personAttributeAuditSelectors.selectAll
);

//personStaffinfo
export const getPersonStaffGroupAuditLoaded = createSelector(
  getPersonStaffGroupAuditState,
  state => state.loaded
);
export const getPersonStaffGroupAuditLoading = createSelector(
  getPersonStaffGroupAuditState,
  state => state.loading
);
export const getPersonStaffGroupAudits = createSelector(
  getPersonStaffGroupAuditState,
  fromPersonProfile.staffInfoAuditSelectors.selectAll
);

//staffinfo
export const getStaffInfoAuditLoaded = createSelector(
  getStaffInfoAuditState,
  state => state.loaded
);
export const getStaffInfoAuditLoading = createSelector(
  getStaffInfoAuditState,
  state => state.loading
);
export const getStaffInfoAudits = createSelector(
  getStaffInfoAuditState,
  fromPersonProfile.staffInfoAuditSelectors.selectAll
);

//preferences
export const getPreferenceCateringAuditLoaded = createSelector(
  getPreferenceCateringAuditState,
  state => state.loaded
);
export const getPreferenceCateringAuditLoading = createSelector(
  getPreferenceCateringAuditState,
  state => state.loading
);
export const getPreferenceCateringAudits = createSelector(
  getPreferenceCateringAuditState,
  fromPersonProfile.preferenceAuditSelectors.selectAll
);

export const getPreferenceGroundTransportationAuditLoaded = createSelector(
  getPreferenceGroundTransportationAuditState,
  state => state.loaded
);
export const getPreferenceGroundTransportationAuditLoading = createSelector(
  getPreferenceGroundTransportationAuditState,
  state => state.loading
);
export const getPreferenceGroundTransportationAudits = createSelector(
  getPreferenceGroundTransportationAuditState,
  fromPersonProfile.preferenceAuditSelectors.selectAll
);

export const getPreferenceHotelAuditLoaded = createSelector(
  getPreferenceHotelAuditState,
  state => state.loaded
);
export const getPreferenceHotelAuditLoading = createSelector(
  getPreferenceHotelAuditState,
  state => state.loading
);
export const getPreferenceHotelAudits = createSelector(
  getPreferenceHotelAuditState,
  fromPersonProfile.preferenceAuditSelectors.selectAll
);

//executiveassociate
export const getExecutiveAssociateAuditLoaded = createSelector(
  getExecutiveAssociateAuditState,
  state => state.loaded
);
export const getExecutiveAssociateAuditLoading = createSelector(
  getExecutiveAssociateAuditState,
  state => state.loading
);
export const getExecutiveAssociateAudits = createSelector(
  getExecutiveAssociateAuditState,
  fromPersonProfile.executiveAssociatonAuditSelectors.selectAll
);

export const getExecutiveAssociatePhoneNumberAuditLoaded = createSelector(
  getExecutiveAssociatePhoneNumberAuditState,
  state => state.loaded
);
export const getExecutiveAssociatePhoneNumberAuditLoading = createSelector(
  getExecutiveAssociatePhoneNumberAuditState,
  state => state.loading
);
export const getExecutiveAssociatePhoneNumberAudits = createSelector(
  getExecutiveAssociatePhoneNumberAuditState,
  fromPersonProfile.executiveAssociatonPhoneNumberAuditSelectors.selectAll
);

export const getExecutiveAssociateEmailAuditLoaded = createSelector(
  getExecutiveAssociateEmailAuditState,
  state => state.loaded
);
export const getExecutiveAssociateEmailAuditLoading = createSelector(
  getExecutiveAssociateEmailAuditState,
  state => state.loading
);
export const getExecutiveAssociateEmailAudits = createSelector(
  getExecutiveAssociateEmailAuditState,
  fromPersonProfile.executiveAssociatonEmailAuditSelectors.selectAll
);

//crewmembertyperating
export const getCrewMemberTypeRatingAuditLoaded = createSelector(
  getCrewMemberTypeRatingAuditState,
  state => state.loaded
);
export const getCrewMemberTypeRatingAuditLoading = createSelector(
  getCrewMemberTypeRatingAuditState,
  state => state.loading
);
export const getCrewMemberTypeRatingAudits = createSelector(
  getCrewMemberTypeRatingAuditState,
  fromPersonProfile.crewMemberTypeRatingAuditSelectors.selectAll
);

//crewmembertyperatingtypes
export const getCrewMemberTypeRatingTypesLoaded = createSelector(
  getCrewMemberTypeRatingTypesState,
  state => state.loaded
);
export const getCrewMemberTypeRatingTypesLoading = createSelector(
  getCrewMemberTypeRatingTypesState,
  state => state.loading
);
export const getCrewMemberTypeRatingTypes = createSelector(
  getCrewMemberTypeRatingTypesState,
  fromPersonProfile.crewMemberTypeRatingTypeSelectors.selectAll
);

//taxinfo
export const getTaxInfoAuditLoaded = createSelector(getTaxInfoAuditState, state => state.loaded);
export const getTaxInfoAuditLoading = createSelector(getTaxInfoAuditState, state => state.loading);
export const getTaxInfoAudits = createSelector(
  getTaxInfoAuditState,
  fromPersonProfile.taxInfoAuditSelectors.selectAll
);

//Passenger
export const getPassengerAuditLoaded = createSelector(
  getPassengerAuditState,
  state => state.loaded
);
export const getPassengerAuditLoading = createSelector(
  getPassengerAuditState,
  state => state.loading
);
export const getPassengerAudits = createSelector(
  getPassengerAuditState,
  fromPersonProfile.passengerAuditSelectors.selectAll
);
